module.exports = __webpack_public_path__ + "img/offer.1a1c0809.svg";